<template>
  <div>
    <app-heading :text="'Active Services'" :heading="'main'"></app-heading>

    <v-row class="mb-4">
      <v-col cols="12" sm="9" md="9" class="py-0">
        <v-row>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Includes Cancelled"
              v-model="filterCancelled"
              class="custom-width"
              @change="getOrdersData()"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="exportRecords()"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
          >Export Records</v-btn
        >
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <app-search @search="search"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh; width: 100%"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
      @cellClicked="onRowClicked"
    ></ag-grid-vue>

    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>

    <create-nbn-order
      ref="createOrder"
      :showNewNbnOrder="showNewNbnOrder"
      :new-order="newOrder"
      @closeNbnOrder="closeNewOrder()"
      @orderSubmitted="closeNewOrder()"
      :filteredParties ="parties"
      :requireWholesalerSelection="requireWholesalerSelection"
    ></create-nbn-order>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import TableActions from "@/components/common/nbn-table-actions";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "NbnActiveOrderManagement",
  components: { AgGridVue },
  data: () => ({
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: ""
    },
    filterCancelled: false,
    nbnDataOptions: {},
    page: 1,
    currentPage: 1,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true
    },
    showNewNbnOrder: false,
    columnDefs: null,
    gridOptions: {},
    items: null,
    frameworkComponents: null,
    newOrder: {
      contactNumber: "1800828668",
      contactFirstname: "2SG",
      contactSurname: "Support"
    },
    orderStatusFilter: [],
    filterCompleted: false,
    filterInProgress: false,
    filterRejected: false,
    parties: [],
    requireWholesalerSelection: false,
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.$refs.createOrder.setWholesaler();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.frameworkComponents = {
      tableActions: TableActions
    };
    vm.columnDefs = [
      {
        headerName: "Actions",
        field: "actions",
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function(param) {
            switch (param.type) {
              case "order":
                vm.showOriginal(param);
                break;
            }
          }
        },
        maxWidth: 200
      },
      {
        headerName: "Type",
        field: "orderType",
        sortable: true,
        maxWidth: 150,
        filter: true
      },
      {
        headerName: "Order ID",
        field: "nbnOrderId",
        sortable: true,
        filter: true,
        maxWidth: 195
      },
      {
        headerName: "AVC ID",
        field: "avcId",
        sortable: true,
        filter: true,
        maxWidth: 195
      },
      {
        headerName: "Technology Type",
        field: "productType",
        sortable: true,
        filter: true,
        maxWidth: 195
      },
      {
        headerName: "Radius Status",
        field: "radiusStatus",
        sortable: true,
        filter: true,
        maxWidth: 195,
        cellStyle: function(params) {
          if (params.value == "Online") {
            return { color: "green" };
          } else if (params.value == "Offline") {
            return { color: "red" };
          }
        },
        valueGetter: params => {
          return `${
            params.data.status.toLowerCase() == "cancelled" ||
            params.data.status.toLowerCase() == "disconnected"
              ? "Offline"
              : params.data.status.toLowerCase() == "rejected"
              ? "N/A"
              : params.data.radiusStatus
          }`;
        }
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        editable: true,
        sortable: true,
        filter: true,
        valueGetter: params => {
          return `${
            params.data.customerFirstname ? params.data.customerFirstname : ""
          } ${params.data.customerSurname ? params.data.customerSurname : ""}`;
        }
      },
      {
        headerName: "Wholesaler Name",
        field: "wholesaler",
        sortable: true,
        filter: true
      },
      {
        headerName: "Auth Date",
        field: "customerAuthDate",
        sortable: true,
        sort: "desc",
        valueFormatter: param => {
          return vm.$options.filters.formatDateTime(param.value);
        },
        maxWidth: 150,
        filter: true
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        valueFormatter: param => {
          return vm.$options.filters.formatStatus(param.value);
        },
        cellStyle: function(params) {
          if (params.value == "Complete") {
            return { color: "green" };
          } else if (params.value == "Rejected") {
            return { color: "red" };
          }
        },
        resizable: true,
        minWidth: 160,
        maxWidth: 220,
        cellRenderer: "tableActions"
      },
      {
        headerName: "Ticket #",
        field: "kayakoConversation",
        sortable: true,
        filter: true,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function(param) {
            vm.showKayakoConversation(param);
          },
          shouldRedirect: vm.shouldRedirect
        },
        maxWidth: 120
      }
    ];

    vm.defaultColDef = {
      autoHeight: true,
      resizable: true
    };
    vm.getOrdersData();
  },
  computed: {
    filteredItems: function() {
      let vm = this;

      return vm.items;
    },
    shouldRedirect() {
      let vm = this;
      let redirect = true;

      if ((vm.impersonating !== null && !vm.isUserMember) || !vm.isAdmin)
        redirect = false;

      return redirect;
    }
  },
  methods: {
    technologyType(payload) {
      let type = "";
      switch (payload) {
        case "Fibre":
          type = "Fibre";
          break;
        case "Fibre To The Building":
          type = "FTTB";
          break;
        case "Fibre To The Node":
          type = "FTTN";
          break;
        case "Fibre To The Curb":
          type = "FTTC";
          break;
        case "Wireless":
          type = "Fixed Wireless";
          break;
        case "HFC":
          type = "HFC";
          break;
      }

      return type;
    },
    exportRecords() {
      let vm = this;
      var headers = [
        "Order Id",
        "AVC Id",
        "Location Id",
        "Technology Type",
        "Cpi Id",
        "Ntd Id",
        "Customer Name",
        "Auth Date",
        "Completed Date",
        "Service Status",
        "Kayako Ticket Id"
      ];
      let payload = {
        statusFilter: []
      };

      if (vm.filterCancelled) payload.statusFilter = [1, 2, 3, 4, 5, 6, 7];
      else payload.statusFilter.push(5);

      vm.getExportableNbnOrders(payload)
        .then(data => {
          vm.exportCSVFile(headers, data, vm.gettimestamp());
        })
        .catch(() => {});
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    gettimestamp() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return "NBN Direct Active Services " + date + " " + time;
    },
    convertToCSV(objArray) {
      const array =
        typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
      let str = "";
      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (const index in array[i]) {
          if (line !== "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      let vm = this;
      if (headers) {
        items.unshift(headers);
      }
      const jsonObject = JSON.stringify(items);
      const csv = vm.convertToCSV(jsonObject);
      const exportedFilenmae = fileTitle + ".csv" || "export.csv"; // eslint-disable-line
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getOrdersData() {
      let vm = this;

      if (!vm.filterCancelled) vm.orderStatusFilter.push(5);

      var search = {
        keyword: null,
        statusFilter: vm.orderStatusFilter,
        pageSize: vm.paging.pageSize,
        pageNumber: vm.paging.pageNo
      };

      vm.getNbnConnectOrders(search)
        .then(data => {
          // Validate that data.items exists and is an array
          if (!data || !data.items || !Array.isArray(data.items)) {
            console.error("Invalid data structure received:", data);
            vm.items = [];
            return;
          }
          var radiusUsernames = [];
          data.items.forEach(x => {
            try {
              if (x.orderType && x.orderType.toLowerCase() === "nbn") {
                x.orderType = "NBN";

                // Safely parse and access _sqResponse data
                if (x._sqResponse && typeof x._sqResponse === "string") {
                  try {
                    const sqResponse = JSON.parse(x._sqResponse);
                    if (
                      sqResponse &&
                      sqResponse.parameters &&
                      sqResponse.parameters.parameter &&
                      Array.isArray(sqResponse.parameters.parameter)
                    ) {
                      sqResponse.parameters.parameter.forEach(param => {
                        if (param.name === "PrimaryAccessTechnology")
                          x.productType = vm.technologyType(param.value);
                      });
                    }
                  } catch (sqParseError) {
                    console.warn(
                      "Failed to parse _sqResponse for order:",
                      x.nbnOrderId,
                      sqParseError
                    );
                    // Set a default product type if parsing fails
                    x.productType = "Unknown";
                  }
                }

                if (x.radiusUsername !== null && x.radiusUsername !== "") {
                  radiusUsernames.push(x.radiusUsername);
                }
              } else {
                // Handle non-NBN orders
                if (x.request && typeof x.request === "string") {
                  try {
                    var request = JSON.parse(x.request);
                    x.productType = request.productType;
                    if (x.radiusUsername != null && x.radiusUsername != "") {
                      radiusUsernames.push(x.radiusUsername);
                    } else if (
                      request.existingRadiusUsername !== undefined &&
                      request.existingRadiusUsername != ""
                    ) {
                      radiusUsernames.push(request.existingRadiusUsername);
                    } else {
                      x.radiusStatus = "N/A";
                    }
                  } catch (requestParseError) {
                    console.warn(
                      "Failed to parse request for order:",
                      x.nbnOrderId,
                      requestParseError
                    );
                    x.productType = "Unknown";
                    x.radiusStatus = "N/A";
                  }
                } else {
                  x.productType = "Unknown";
                  x.radiusStatus = "N/A";
                }
              }
            } catch (orderError) {
              console.error(
                "Error processing order:",
                x.nbnOrderId,
                orderError
              );
              // Set default values to prevent further errors
              x.productType = "Error";
              x.radiusStatus = "N/A";
            }
          });

          var radiusStatusPayload = { radiusUsername: radiusUsernames };
          vm.getServiceRadiusStatus(radiusStatusPayload)
            .then(response => {
              data.items.forEach((x, index) => {
                try {
                  if (x.orderType && x.orderType.toLowerCase() === "nbn") {
                    if (x.radiusUsername != null && x.radiusUsername != "")
                      x.radiusStatus = response[x.radiusUsername];
                    else x.radiusStatus = "N/A";
                  } else {
                    // Handle non-NBN orders
                    if (x.request && typeof x.request === "string") {
                      try {
                        var request = JSON.parse(x.request);
                        if (x.status == "Rejected") {
                          x.radiusStatus = "N/A";
                        } else {
                          if (
                            x.radiusUsername != null &&
                            x.radiusUsername != ""
                          ) {
                            x.radiusStatus = response[x.radiusUsername];
                          } else if (
                            request.existingRadiusUsername !== undefined &&
                            request.existingRadiusUsername != ""
                          ) {
                            x.radiusStatus =
                              response[request.existingRadiusUsername];
                          } else {
                            x.radiusStatus = "N/A";
                          }
                        }
                      } catch (requestParseError) {
                        console.warn(
                          "Failed to parse request for radius status for order:",
                          x.nbnOrderId,
                          requestParseError
                        );
                        x.radiusStatus = "N/A";
                      }
                    } else {
                      x.radiusStatus = "N/A";
                    }
                  }

                  if (x.status && x.status.toLowerCase() == "disconnected") {
                    x.radiusStatus = "Cancelled";
                  }
                } catch (radiusError) {
                  console.error(
                    "Error processing radius status for order:",
                    x.nbnOrderId,
                    radiusError
                  );
                  x.radiusStatus = "N/A";
                }
              });
              vm.orderStatusFilter = [];
              vm.items = data.items;
              vm.nbnDataOptions = data;
              vm.gridApi.sizeColumnsToFit();
            })
            .catch(error => {
              console.error("getServiceRadiusStatus failed:", error);
              // Even if radius status fails, we should still show the orders
              vm.orderStatusFilter = [];
              vm.items = data.items;
              vm.nbnDataOptions = data;
              if (vm.gridApi) {
                vm.gridApi.sizeColumnsToFit();
              }
            });
        })
        .catch(e => {
          console.error("getNbnConnectOrders failed:", e);
          vm.items = [];
        });
    },
    paginationChange(val) {
      this.paging.pageNo = val;
      this.getOrdersData();
    },
    createNbnOrder(data) {
      let vm = this;
      vm.newOrder = {};
      vm.requireWholesalerSelection = true;
      vm.setOriginal(false);
      vm.setLocationID("");
      vm.resetFormattedSQResult();
      vm.setSqResult({});
      vm.setOrderType("nbn");
      vm.createOrder(data);
      if (vm.wholesalers.length === 1) vm.$refs.createOrder.checkLayer();
    },
    showKayakoConversation(item) {
      let newItem = item.customerReference;
      if (item.customerReference.includes("_")) {
        newItem = item.customerReference.slice(
          item.customerReference.indexOf("_") + 1,
          item.customerReference.length
        );
      }
      var authDate = new Date(item.customerAuthDate);
      var zammadDeployDate = new Date("2024-04-18");
      if (authDate >= zammadDeployDate) {
        window.open(
          `https://zammad.vonex.com.au/#search/number:${newItem}`,
          "_blank"
        );
      } else {
        window.open(
          `https://vonex.kayako.com/agent/conversations/${newItem}`,
          "_blank"
        );
      }
    },
    search(keyword) {
      let vm = this;
      vm.paging.keyword = keyword;
      vm.keyword = keyword;

      if (!vm.filterCancelled) vm.orderStatusFilter.push(5);

      var search = {
        keyword: keyword,
        statusFilter: vm.orderStatusFilter,
        pageSize: 50,
        pageNumber: 1
      };

      vm.getNbnConnectOrders(search)
        .then(data => {
          // Validate that data.items exists and is an array
          if (!data || !data.items || !Array.isArray(data.items)) {
            console.error("Invalid data structure received:", data);
            vm.items = [];
            return;
          }
          var radiusUsernames = [];
          data.items.forEach(x => {
            try {
              if (x.orderType && x.orderType.toLowerCase() === "nbn") {
                x.orderType = "NBN";

                // Safely parse and access _sqResponse data
                if (x._sqResponse && typeof x._sqResponse === "string") {
                  try {
                    const sqResponse = JSON.parse(x._sqResponse);
                    if (
                      sqResponse &&
                      sqResponse.parameters &&
                      sqResponse.parameters.parameter &&
                      Array.isArray(sqResponse.parameters.parameter)
                    ) {
                      sqResponse.parameters.parameter.forEach(param => {
                        if (param.name === "PrimaryAccessTechnology")
                          x.productType = vm.technologyType(param.value);
                      });
                    }
                  } catch (sqParseError) {
                    console.warn(
                      "Failed to parse _sqResponse for order:",
                      x.nbnOrderId,
                      sqParseError
                    );
                    x.productType = "Unknown";
                  }
                }

                if (x.radiusUsername !== null && x.radiusUsername !== "") {
                  radiusUsernames.push(x.radiusUsername);
                }
              } else {
                // Handle non-NBN orders
                if (x.request && typeof x.request === "string") {
                  try {
                    var request = JSON.parse(x.request);
                    x.productType = request.productType;
                    if (x.radiusUsername != null && x.radiusUsername != "") {
                      radiusUsernames.push(x.radiusUsername);
                    } else if (
                      request.existingRadiusUsername !== undefined &&
                      request.existingRadiusUsername != ""
                    ) {
                      radiusUsernames.push(request.existingRadiusUsername);
                    } else {
                      x.radiusStatus = "N/A";
                    }
                  } catch (requestParseError) {
                    console.warn(
                      "Failed to parse request for order:",
                      x.nbnOrderId,
                      requestParseError
                    );
                    x.productType = "Unknown";
                    x.radiusStatus = "N/A";
                  }
                } else {
                  x.productType = "Unknown";
                  x.radiusStatus = "N/A";
                }
              }
            } catch (orderError) {
              console.error(
                "Error processing order:",
                x.nbnOrderId,
                orderError
              );
              x.productType = "Error";
              x.radiusStatus = "N/A";
            }
          });

          var radiusStatusPayload = { radiusUsername: radiusUsernames };
          vm.getServiceRadiusStatus(radiusStatusPayload)
            .then(response => {
              data.items.forEach(x => {
                try {
                  if (x.orderType && x.orderType.toLowerCase() === "nbn") {
                    if (x.radiusUsername != null && x.radiusUsername != "")
                      x.radiusStatus = response[x.radiusUsername];
                    else x.radiusStatus = "N/A";
                  } else {
                    // Handle non-NBN orders
                    if (x.request && typeof x.request === "string") {
                      try {
                        var request = JSON.parse(x.request);
                        if (x.status == "Disconnected") {
                          x.radiusStatus = "Cancelled";
                        } else if (x.status == "Rejected") {
                          x.radiusStatus = "N/A";
                        } else {
                          if (
                            x.radiusUsername != null &&
                            x.radiusUsername != ""
                          ) {
                            x.radiusStatus = response[x.radiusUsername];
                          } else if (
                            request.existingRadiusUsername !== undefined &&
                            request.existingRadiusUsername != ""
                          ) {
                            x.radiusStatus =
                              response[request.existingRadiusUsername];
                          } else {
                            x.radiusStatus = "N/A";
                          }
                        }
                      } catch (requestParseError) {
                        console.warn(
                          "Failed to parse request for radius status for order:",
                          x.nbnOrderId,
                          requestParseError
                        );
                        x.radiusStatus = "N/A";
                      }
                    } else {
                      x.radiusStatus = "N/A";
                    }
                  }
                } catch (radiusError) {
                  console.error(
                    "Error processing radius status for order:",
                    x.nbnOrderId,
                    radiusError
                  );
                  x.radiusStatus = "N/A";
                }
              });
              vm.orderStatusFilter = [];
              vm.items = data.items;
              vm.gridApi.sizeColumnsToFit();
            })
            .catch(error => {
              console.error("getServiceRadiusStatus failed in search:", error);
              // Even if radius status fails, we should still show the orders
              vm.orderStatusFilter = [];
              vm.items = data.items;
              if (vm.gridApi) {
                vm.gridApi.sizeColumnsToFit();
              }
            });
        })
        .catch(e => {
          console.error("getNbnConnectOrders failed:", e);
          vm.items = [];
        });
    },
    modifyNbnOrder(data) {
      let vm = this;
      vm.showNewNbnOrder = true;
    },
    createOrder(details) {
      let vm = this;

      vm.showNewNbnOrder = true;
    },
    closeNewOrder() {
      let vm = this;
      vm.showNewNbnOrder = false;
      vm.requireWholesalerSelection = false;
      vm.resetNbnOrderDetails();
    },
    showOriginal(item) {
      let vm = this;

      vm.setLocationID(item.locationId);
      if (item.orderType.toLowerCase() === "nbn") vm.setOldOrder(true);
      vm.setOrderType(item.orderType.toLowerCase());
      vm.setOriginal(true);
      vm.setEditForm(false);
      vm.$refs.createOrder.displayOrder(item, {});
      vm.showNewNbnOrder = true;
      vm.checkHardwareModem(item);
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      var payload = { quoteID: args.data.quoteId };
    }
  }
};
</script>

<style scoped></style>
